const convertImageToBlob = (canvasElement) => {
	return new Promise((resolve) => {
		canvasElement.toBlob((blob) => resolve(blob));
	});
};
export default convertImageToBlob;
